module.exports = __webpack_public_path__ + "static/media/test-kit.a7a4569e.svg";